export default __webpack_public_path__ + "static/img-tailor-intelligent-planning-72e2caf323485ef03f032860a151ca9e.png";